export const ORDER_RESTORE_HIDDEN_COUPON_TYPES = ['MARKETING_COUPON', 'MAILING_COUPON', 'ONE_TIME_COUPON']
export const ORDER_NON_PRODUCT_TYPES = ['MARKETING_COUPON', 'EXTRA_DISCOUNT', 'PLATFORM_FEE', 'STAMP_VOUCHER', 'MAILING_COUPON', 'SMALL_ORDER_FEE', 'ONE_TIME_COUPON']
export const INVOICE_NON_PRODUCT_TYPES = ['MARKETING_COUPON', 'EXTRA_DISCOUNT', 'PLATFORM_FEE', 'DISCOUNT', 'CATEGORY_DISCOUNT', 'DELIVERY_COST', 'ONE_TIME_COUPON']
export const REASON_CODE_TO_KEY = {
	INVALID_ORDER: 'order.modal.abortOrder.INVALID_ORDER',
	CANCELLED_BY_CLIENT: 'order.modal.abortOrder.CANCELLED_BY_CLIENT',
	OTHER: 'order.modal.abortOrder.OTHER',
}
